@let idx = index() + 1;
<app-expansion-panel [titre]="'Interrelation ' + idx" [item]="form" [isOpen]="true">
  <div class="px-lg pt-lg pb-xl">
    <form class="gap-lg flex flex-col" [formGroup]="form()">
      <div hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel labelRequired>Nom</label>
        <hlm-autocomplete
          [(search)]="search"
          [id]="'nom-' + idx"
          [filteredOptions]="toutesLesInterrelations()"
          [optionTemplate]="option"
          [autocompleteSearchClass]="isFormInvalid() ? 'border-danger border' : 'border-grey-3 border'"
          (searchChange)="onSearchChange($event)"
          formControlName="interrelation"
        >
          <ng-template #option let-option>{{ option.nom }}</ng-template>
        </hlm-autocomplete>
        @if (isFormInvalid()) {
          <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
        }
      </div>

      <div hlmField>
        <label [for]="'select-phases' + idx" hlmFieldLabel>Phases liées</label>
        <hlm-select [id]="'select-phases-' + idx" formControlName="phases" multiple>
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (phase of phases(); track $index) {
              <hlm-option [value]="phase">
                <label hlmLabel>{{ phase.nom }}</label>
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
        @if (phasesForm.hasError('required') && phasesForm.touched) {
          <hlm-field-error>Merci de sélectionner au moins une phase</hlm-field-error>
        }
      </div>
    </form>
  </div>
</app-expansion-panel>
